import { Tag } from 'antd'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { frameTheatreAddress } from '../../common/util/helper'

import '../../style/compositions.less'

class FilterTags extends React.Component {
  render () {
    const {compositionFilters: {theatres}, toggleTheatreFilter} = this.props

    return (
      <div className="qw-m-small">
        {theatres.map(theatre =>
          <Tag
            key={theatre.id} closable={true}
            className="composition-card qw-my-xx-small qw-mx-xx-small qw-p-small qw-border-none qw-not-rounded search-tag qw-font-size-small qw-font-size-small qw-line-height-small"
            onClose={() => toggleTheatreFilter({id: theatre.id})}>
            {I18n.t(`compositions.filterLabel.theatre`)}:&nbsp;{theatre.name}, <span
            className="location qw-font-size-x-small qw-font-weight-medium qw-color-text-secondary-heading qw-mt-xx-small">{frameTheatreAddress(theatre)}</span>
          </Tag>
        )}
      </div>
    )
  }
}

export default FilterTags



// WEBPACK FOOTER //
// ./src/app/components/compositions/FilterTag.js